import React, { Fragment, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { languageFormatter } from '../../../lib/formatter';

const Login = ({
  t,
  language,
  countryNumber,
  phoneNumber,
  password,
  countryInfoList,
  setCountryNumber,
  setPhoneNumber,
  setPassword,
  changeLanguage,
  loginApi,
  history,
  location,
}) => {
  const [ isOpen, setIsOpen ] = useState(false);

  const languageItems = [
    { name: '한국어', value: 'ko' },
    { name: 'English', value: 'en' },
  ];

  const login = async () => {
    try {
      await loginApi();
      history.push('/home');
    } catch (error) {
      return;
    }
  };

  const simpleLogin = (key) => {
    if (key === 'Enter') login();
    else return;
  }

  const validateRequestParams = () => {
    return countryNumber === '' || phoneNumber === '' || password === '';
  };

  window.addEventListener('popstate', () => {
    if (!localStorage.getItem('api_key')) history.replace('/login');
  });

  return (
    <Fragment>
      <div className='sign-wrapper'>
        <div className='signing'>
          <div className="logo-wrapper">
            {/* <div className="logo"></div> */}
            <p className='logo-title'>{t('company_title')}</p>
          </div>
          <div className='sign-box'>
            <div className='input-box'>
              <div className='form-select'>
                <select onChange={e => setCountryNumber(e.target.value)}>
                  {countryInfoList.map((country, index) => (
                    <option key={`country-index-${index}`} value={country.phone}>{`${country.name} ( +${country.phone} )`}</option>
                  ))}
                </select>
              </div>
              <div className='form-input'>
                <input
                  placeholder={t('placeholder.phone_number')}
                  maxLength='11'
                  onChange={e => setPhoneNumber(e.target.value)}
                />
              </div>
              <div className='form-input'>
                <input
                  type='password'
                  placeholder={t('placeholder.password')}
                  onChange={e => setPassword(e.target.value)}
                  onKeyPress={e => simpleLogin(e.key)}
                />
              </div>
              <div className='btn-login'>
                <button disabled={validateRequestParams()} onClick={login}>{t('button.login')}</button>
              </div>
            </div>
          </div>
          <div className='p-relative'>
            <Dropdown
              className='p-absolute right-30 w-unset'
              onMouseOver={() => setIsOpen(true)}
              onMouseLeave={() => setIsOpen(false)}
              onClick={e => e.stopPropagation()}
            >
              <Dropdown.Toggle className='br-unset' variant="success" id="dropdown-basic" onClick={e => e.stopPropagation()}>
                <p className='m-0-5 selected-item'>{languageFormatter(language)}</p>
                <FontAwesomeIcon icon={faCaretDown}/>
              </Dropdown.Toggle>
              <Dropdown.Menu show={isOpen}>
                <div className=''>
                  {languageItems.map((item, index) => (
                    <span
                      key={index}
                      className={`dropdown-lang-item ${language === item.value ? 'selected':''}`}
                      href='#'
                      onClick={() => changeLanguage(item.value)}
                    >
                      {item.name}
                    </span>
                  ))}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          {/* <p className='copyright'>COPYRIGHT ⓒImGATE ALL RIGHTS RESERVED.</p> */}
        </div>
      </div>
    </Fragment>
  );
}

export default Login;